<template>
  <sparkline
    :id="id"
    :options="options"
    :color="color"
    :value="`${value}%`"
    :year="`${year} grads`"
    :size="size"
    :title="title"
    :help="help"
    :url="url"
  />
</template>

<script setup>
import Sparkline from "@/components/sparklines/Sparkline.vue"
import colors from "@/colors"
import route from "ziggy-js"
import { computed, ref } from "vue"

const props = defineProps({
  school: { type: Object, required: true },
  field: { type: String, required: true },
  size: { type: String, default: "sm" },
  title: { type: String },
  help: { type: String },
})

const id = computed(() => `${props.school.slug}-${props.field}`)

const url = computed(() => route("schools.jobs", props.school.slug))

const data = computed(() => {
  return props.school[props.field]
})

const latest = computed(() => data.value[data.value.length - 1])
const first = computed(() => data.value[0])

const year = ref(latest.value.year)
const value = ref(latest.value.percent)

const color = computed(() => {
  switch (props.field) {
    case "public_service_percent": return colors.yellow[500]
    case "federal_clerkship_percent": return colors.indigo[500]
    case "national_firm_percent": return colors.blue[900]
    case "regional_firm_percent": return colors.blue[800]
    case "small_firm_percent": return colors.blue[700]
    default: return colors.sky[500]
  }
})

const options = computed(() => {
  const series = [{
    type: "areaspline",
    data: data.value.map(i => i.percent),
    point: {
      events: {
        mouseOver() {
          value.value = this.y
          year.value = this.x + first.value.year
        },
        mouseOut() {
          year.value = latest.value.year
          value.value = data.value[data.value.length - 1].percent
        },
      },
    },
  }]

  return {
    series,
  }
})
</script>
